import { Boot, SlateTransforms } from "@wangeditor/editor";

// const IMAGE_MAX_SIZE = 10;
// const VIDEO_MAX_SIZE = 500;
const editorVmMap = new WeakMap();

let videoHtmlRegistered = false;
let mediaPastePluginRegistered = false;

function isVideoFile(file) {
  const type = ((file && file.type) || "").toLowerCase();
  const name = ((file && file.name) || "").toLowerCase();
  return type.indexOf("video/") === 0 || /\.(mp4|webm|ogg|mov|m4v|avi)$/i.test(name);
}

function isImageFile(file) {
  const type = ((file && file.type) || "").toLowerCase();
  const name = ((file && file.name) || "").toLowerCase();
  return type.indexOf("image/") === 0 || /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(name);
}

function ensureEditorFocus(editor) {
  if (!editor) {
    return false;
  }
  try {
    if (typeof editor.restoreSelection === "function") {
      editor.restoreSelection();
    }
  } catch (e) {
    // ignore
  }
  if (typeof editor.focus === "function") {
    editor.focus(!editor.selection);
  }
  return !!editor.selection;
}

function insertImageHtml(editor, url) {
  if (!editor || !url) {
    return;
  }
  ensureEditorFocus(editor);
  editor.dangerouslyInsertHtml(`<img src="${url}">`);
}

function insertVideoHtml(editor, url) {
  if (!editor || !url) {
    return;
  }
  ensureEditorFocus(editor);
  const videoNode = {
    type: "video",
    src: url,
    poster: "",
    width: "100%",
    height: "auto",
    children: [{ text: "" }]
  };
  try {
    SlateTransforms.insertNodes(editor, videoNode);
    if (typeof editor.move === "function") {
      editor.move(1);
    }
  } catch (e) {
    const at = [editor.children.length];
    SlateTransforms.insertNodes(editor, videoNode, { at: at });
  }
}

export function bindEditorVm(editor, vm) {
  if (editor && vm) {
    editorVmMap.set(editor, vm);
  }
}

/**
 * 粘贴/拖拽混合文件时，把视频从图片上传链路中拆出来
 */
export function registerMediaPastePlugin() {
  if (mediaPastePluginRegistered) {
    return;
  }
  mediaPastePluginRegistered = true;
  Boot.registerPlugin((editor) => {
    const { insertData } = editor;
    editor.insertData = (data) => {
      const files = Array.from((data && data.files) || []);
      const vm = editorVmMap.get(editor);
      const videos = files.filter(isVideoFile);
      if (!vm || !files.length || !videos.length) {
        insertData(data);
        return;
      }
      const images = files.filter(isImageFile);
      handleMixedMediaFiles(editor, vm, images, videos);
    };
    return editor;
  });
}

async function handleMixedMediaFiles(editor, vm, images, videos) {
  const total = images.length + videos.length;
  vm.beginMediaUpload(total);
  for (let i = 0; i < images.length; i++) {
    const file = images[i];
    // if (isOverSize(file, IMAGE_MAX_SIZE * 1024 * 1024)) {
    //   vm.$message.warning(`${file.name} 超过 ${IMAGE_MAX_SIZE}MB，已跳过`);
    //   vm.finishMediaUpload(false);
    //   continue;
    // }
    await uploadAndInsert(vm, file, "upload/richtxt-img", (url) => {
      insertImageHtml(editor, url);
    });
  }
  for (let i = 0; i < videos.length; i++) {
    const file = videos[i];
    // if (isOverSize(file, VIDEO_MAX_SIZE * 1024 * 1024)) {
    //   vm.$message.warning(`${file.name} 超过 ${VIDEO_MAX_SIZE}MB，已跳过`);
    //   vm.finishMediaUpload(false);
    //   continue;
    // }
    await uploadAndInsert(vm, file, "upload/richtext_video", (url) => {
      insertVideoHtml(editor, url);
    });
  }
}

/**
 * 视频仅保留基础播放控件，关闭全屏和倍速
 */
export function registerVideoHtml() {
  if (videoHtmlRegistered) {
    return;
  }
  videoHtmlRegistered = true;
  Boot.registerElemToHtml({
    type: "video",
    elemToHtml(elem) {
      const src = ((elem && elem.src) || "").trim();
      const poster = (elem && elem.poster) || "";
      const width = (elem && elem.width) || "100%";
      const height = (elem && elem.height) || "auto";
      if (src.indexOf("<iframe ") === 0) {
        return `${src}`;
      }
      const posterAttr = poster ? ` poster="${poster}"` : "";
      return `
<video src="${src}" controls="true" x5-playsinline="true" playsinline="true" webkit-playsinline="true" width="${width}" height="${height}" preload="metadata" style="text-indent: 0em"${posterAttr}></video>`;
    }
  });
}

export function uploadFile(vm, file, path, onProgress) {
  const now = new Date();
  const h = String(now.getHours()).padStart(2, "0");
  const m = String(now.getMinutes()).padStart(2, "0");
  const s = String(now.getSeconds()).padStart(2, "0");
  console.log(`${h}:${m}:${s}`);
  const params = new FormData();
  params.append("file", file);
  params.append("path", path);
  return vm
    .$http({
      url: global.apiImageUpload + "/oss/image/upload",
      method: "POST",
      body: params,
      timeout: 7200000,
      headers: { "Content-Type": "multipart/form-data" },
      progress(e) {
        if (e.lengthComputable && onProgress) {
          onProgress(Math.round((e.loaded / e.total) * 100));
        }
      },
      uploadProgress(e) {
        if (e.lengthComputable && onProgress) {
          onProgress(Math.round((e.loaded / e.total) * 100));
        }
      }
    })
    .then((res) => {
      const payload = res.body || res.data || {};
      if (payload.apiStatus === 0 && payload.sysStatus === 0) {
        return payload.data;
      }
      return payload.data || "";
    }).catch((err) => {
      debugger
      console.log(err.status, err.statusText, err.body);
    }); ;
}

function pickFiles(accept) {
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", accept);
    input.setAttribute("multiple", "multiple");
    input.style.display = "none";
    input.addEventListener("change", () => {
      resolve(Array.from(input.files || []));
      if (input.parentNode) {
        input.parentNode.removeChild(input);
      }
    });
    document.body.appendChild(input);
    input.click();
  });
}

function isOverSize(file, maxSize) {
  return file && file.size > maxSize;
}

async function uploadAndInsert(vm, file, path, onInsert) {
  try {
    const url = await uploadFile(vm, file, path, (percent) => {
      console.log('percent', percent);
      vm.setMediaUploadPercent(percent);
    });
    if (url) {
      onInsert(url);
      vm.finishMediaUpload(true);
      return true;
    }
    vm.finishMediaUpload(false);
    return false;
  } catch (e) {
    vm.finishMediaUpload(false);
    return false;
  }
}

export function createEditorConfig(vm) {
  const placeholder =
    (vm.options && vm.options.placeholder) || "请输入富文本";
  return {
    placeholder,
    autoFocus: false,
    customAlert: (info, type) => {
      const map = { success: "success", warning: "warning", error: "error" };
      vm.$message({
        message: info,
        type: map[type] || "info"
      });
    },
    MENU_CONF: {
      lineHeight: {
        lineHeightList: ["1", "1.5", "1.75", "2", "3", "4", "5"]
      },
      uploadImage: {
        // maxFileSize: IMAGE_MAX_SIZE * 1024 * 1024,
        maxFileSize: Number.MAX_SAFE_INTEGER,
        allowedFileTypes: ["image/png", "image/gif", "image/jpeg", "image/webp", "image/*"],
        customBrowseAndUpload: async (insertFn) => {
          const files = await pickFiles("image/png,image/gif,image/jpeg,image/webp");
          // const validFiles = files.filter((file) => {
          //   if (isOverSize(file, IMAGE_MAX_SIZE * 1024 * 1024)) {
          //     vm.$message.warning(`${file.name} 超过 ${IMAGE_MAX_SIZE}MB，已跳过`);
          //     return false;
          //   }
          //   return true;
          // });
          const validFiles = files;
          if (!validFiles.length) {
            return;
          }
          vm.beginMediaUpload(validFiles.length);
          for (let i = 0; i < validFiles.length; i++) {
            await uploadAndInsert(vm, validFiles[i], "upload/richtxt-img", (url) => {
              insertFn(url, "", url);
            });
          }
        },
        customUpload: async (file, insertFn) => {
          if (isVideoFile(file)) {
            // if (isOverSize(file, VIDEO_MAX_SIZE * 1024 * 1024)) {
            //   vm.$message.warning(`视频大小不能超过 ${VIDEO_MAX_SIZE}MB`);
            //   return;
            // }
            vm.beginMediaUpload(1);
            await uploadAndInsert(vm, file, "upload/richtext_video", (url) => {
              insertVideoHtml(vm.editor, url);
            });
            return;
          }
          // if (isOverSize(file, IMAGE_MAX_SIZE * 1024 * 1024)) {
          //   vm.$message.warning(`图片大小不能超过 ${IMAGE_MAX_SIZE}MB`);
          //   return;
          // }
          vm.beginMediaUpload(1);
          await uploadAndInsert(vm, file, "upload/richtxt-img", (url) => {
            insertFn(url, "", url);
          });
        }
      },
      uploadVideo: {
        // maxFileSize: VIDEO_MAX_SIZE * 1024 * 1024,
        maxFileSize: Number.MAX_SAFE_INTEGER,
        allowedFileTypes: ["video/mp4", "video/*"],
        customBrowseAndUpload: async (insertFn) => {
          const files = await pickFiles("video/mp4");
          // const validFiles = files.filter((file) => {
          //   if (isOverSize(file, VIDEO_MAX_SIZE * 1024 * 1024)) {
          //     vm.$message.warning(`${file.name} 超过 ${VIDEO_MAX_SIZE}MB，已跳过`);
          //     return false;
          //   }
          //   return true;
          // });
          const validFiles = files;
          if (!validFiles.length) {
            return;
          }
          vm.beginMediaUpload(validFiles.length);
          for (let i = 0; i < validFiles.length; i++) {
            await uploadAndInsert(vm, validFiles[i], "upload/richtext_video", (url) => {
              insertFn(url);
            });
          }
        },
        customUpload: async (file, insertFn) => {
          // if (isOverSize(file, VIDEO_MAX_SIZE * 1024 * 1024)) {
          //   vm.$message.warning(`视频大小不能超过 ${VIDEO_MAX_SIZE}MB`);
          //   return;
          // }
          vm.beginMediaUpload(1);
          await uploadAndInsert(vm, file, "upload/richtext_video", (url) => {
            insertFn(url);
          });
        }
      }
    }
  };
}
